import type { CatalogCategory, CatalogCategoryNode } from '../types'

export const normalizeCategory = (raw: Record<string, unknown>): CatalogCategory => {
  const rawOrder = Number(raw.order)
  return {
    _id: String(raw._id ?? ''),
    name: String(raw.name ?? ''),
    slug: String(raw.slug ?? ''),
    description: typeof raw.description === 'string' ? raw.description : '',
    parentCategoryId: typeof raw.parentCategoryId === 'string' ? raw.parentCategoryId : null,
    order: Number.isFinite(rawOrder) ? rawOrder : undefined,
    imageVariants:
      raw.imageVariants && typeof raw.imageVariants === 'object'
        ? (raw.imageVariants as CatalogCategory['imageVariants'])
        : null,
    status: raw.status === 'inactive' ? 'inactive' : 'active',
  }
}

export const sortCategoriesByOrderAndName = (left: CatalogCategory, right: CatalogCategory) => {
  const leftOrder = typeof left.order === 'number' ? left.order : Number.MAX_SAFE_INTEGER
  const rightOrder = typeof right.order === 'number' ? right.order : Number.MAX_SAFE_INTEGER
  if (leftOrder !== rightOrder) return leftOrder - rightOrder
  return left.name.localeCompare(right.name, 'it', { sensitivity: 'base' })
}

export const buildCategoryChildrenTree = (
  categories: CatalogCategory[],
  parentCategoryId: string,
): CatalogCategoryNode[] =>
  categories
    .filter((category) => category.parentCategoryId === parentCategoryId)
    .sort(sortCategoriesByOrderAndName)
    .map((category) => ({
      ...category,
      children: buildCategoryChildrenTree(categories, category._id),
    }))
